"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHourFormatter = getHourFormatter;
function getHourFormatter(intlFormatters) {
    return (hour) => intlFormatters.formatDate(new Date(2020, 1, 1, hour, 0, 0), {
        hour: 'numeric',
    });
}
//# sourceMappingURL=getHourFormatter.js.map